import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import * as actions from 'data/redux/actions'

import { LoadingIndicator } from 'basecomps'
import { useUser, useGame } from 'data/hooks'


export const Loader = ({loaded}) => {
  
  const dispatch = useDispatch()
  const gameId = useParams().gameId || playmotiv.game.gameId
  const { game } = useGame(gameId)

  useEffect(() => {

    if (!game) return

    Promise.all([
      dispatch(actions.uiSendEventToAWS({
        action: 'start'
      })),
      dispatch(actions.uiMenusLoad()),
    ])
    .then(() => {
      if (loaded) loaded(true)
    })

  }, [game])

  return <LoadingIndicator text="Cargando partida ..." />
}
